import React from 'react';
import '../App.css';
import { NavLink } from 'react-router-dom';

const NeonCard = ({ title, description,route }) => {
  return (
    <div className="neon__card">
      <svg className="neon__icon" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
        <path d="M35.712 6C40.28 6 43.998 9.68403 43.998 14.2103L44 19.5649C44 19.9573 43.842 20.3378 
          43.562 20.6152C43.28 20.8946 42.9 21.0512 42.5 21.0512C40.858 21.0512 39.522 22.375 39.522 
          24.002C39.522 25.629 40.858 26.9528 42.5 26.9528C43.328 26.9528 44 27.6186 44 
          28.4391V33.7917C44 38.318 40.284 42 35.716 42H12.286C7.718 42 4 38.318 4 
          33.7917V28.4391C4 27.6186 4.672 26.9528 5.5 26.9528C7.144 26.9528 8.48 25.629 
          8.48 24.002C8.48 22.4166 7.198 21.2236 5.5 21.2236C5.102 21.2236 4.722 21.067 
          4.44 20.7876C4.158 20.5082 4 20.1297 4 19.7373L4.004 14.2103C4.004 9.68403 
          7.72 6 12.288 6H35.712ZM24.004 16.3069C23.436 16.3069 22.928 16.6201 22.674 
          17.1234L21.216 20.0504L17.964 20.5201C17.402 20.5994 16.942 20.9799 16.764 
          21.5149C16.588 22.05 16.73 22.6286 17.138 23.021L19.496 25.296L18.94 28.5124C18.844 
          29.0673 19.07 29.6182 19.53 29.9491C19.79 30.1334 20.092 30.2286 20.398 30.2286C20.632 
          30.2286 20.868 30.1711 21.084 30.0581L24 28.5401L26.91 30.0542C27.414 30.3217 28.012 
          30.2801 28.47 29.9472C28.932 29.6182 29.158 29.0673 29.062 28.5124L28.504 25.296L30.862 
          23.021C31.272 22.6286 31.414 22.05 31.236 21.5149C31.06 20.9799 30.6 20.5994 30.044 
          20.5221L26.786 20.0504L25.328 17.1254C25.078 16.622 24.57 16.3089 24.004 16.3069Z" />
      </svg>
      <h1 className="neon__title">{title}</h1>
      <p className="neon__description">{description}</p>
      <NavLink to={route} className="neon__button">
        Explore Now
        <svg className="neon__button-icon" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
          <path d="M24.0099 4C29.3698 4 33.7763 8.21182 34 13.5486H33.9477C33.954 13.7038 33.9242 13.8583 
            33.8606 14H34.1729C36.6069 14 39.1557 15.687 40.1777 19.7596L40.2887 20.2401L41.8265 32.6295C42.9332 
            40.5315 38.6099 43.8546 32.7124 43.9938L32.3939 44H15.6085L15.29 43.9938C9.39125 43.8546 5.0679 
            40.5315 6.17453 32.6295L7.71229 20.2401L7.82326 19.7596C8.84531 15.6963 11.3874 14 13.8271 
            14H14.1395C14.0758 13.8583 14.046 13.7038 14.0523 13.5486H14C14.2215 8.21182 18.6303 4 24.0099 4ZM24.0099 
            6.95575C19.8283 6.95575 16.3947 10.3874 16.3947 14.5689C16.3947 18.7504 19.8283 22.182 24.0099 
            22.182C28.1914 22.182 31.625 18.7504 31.625 14.5689C31.625 10.3874 28.1914 6.95575 24.0099 
            6.95575ZM24.0099 20.9963C21.6897 20.9963 19.8049 18.9501 19.8049 16.5C19.8049 14.0499 21.6897 
            12.0037 24.0099 12.0037C26.3301 12.0037 28.2149 14.0499 28.2149 16.5C28.2149 18.9501 26.3301 
            20.9963 24.0099 20.9963ZM24.0099 11.0118C22.2572 11.0118 20.8365 12.4325 20.8365 14.1851C20.8365 
            15.9378 22.2572 17.3585 24.0099 17.3585C25.7626 17.3585 27.1833 15.9378 27.1833 14.1851C27.1833 
            12.4325 25.7626 11.0118 24.0099 11.0118Z" />
        </svg>
      </NavLink>
    </div>
  );
}

export default NeonCard;
